import React from 'react'
import classNames from 'classnames'

import { EloTooltip } from '@elo-ui/components/elo-tooltip'

import { TEST_IDS } from '@elo-ui/types'

import './elo-status-badge.scss'

export type Status = 'success' | 'warning' | 'error' | 'blocked' | 'in-review'

interface Props {
  className?: string
  status?: Status
  icon?: React.ReactNode
  label?: string | React.ReactNode
  tooltipContent?: React.ReactNode | string
  tooltipPlacement?: 'bottom' | 'top' | 'right' | 'left'
  children?: React.ReactNode
  highlight?: boolean
  disabled?: boolean
  backgroundColor?: string
  badgeColor?: string
  dataTestId?: string
  active?: boolean
  onClick?: () => any
}

export const EloStatusBadge: React.FC<Props> = ({
  className,
  status = 'blocked',
  icon,
  label,
  tooltipContent,
  tooltipPlacement = 'top',
  children = <></>,
  highlight = true,
  disabled = false,
  onClick,
  backgroundColor,
  badgeColor,
  dataTestId = TEST_IDS.statusBadge,
  active = true,
}) => {
  const classes = classNames(
    'elo-status-badge',
    `elo-status-badge--${status}`,
    { 'elo-status-badge--active': active },
    { 'elo-status-badge--highlight': highlight },
    { 'elo-status-badge--disabled': disabled },
    { 'elo-status-badge--clickable': onClick },
    className
  )

  return (
    <>
      {tooltipContent ? (
        <EloTooltip content={tooltipContent} placement={tooltipPlacement}>
          <div className={classes} onClick={onClick} data-testid={dataTestId}>
            {icon}
            {label}
            {children}
          </div>
        </EloTooltip>
      ) : (
        <div
          data-testid={dataTestId}
          className={classes}
          style={
            {
              '--elo-status-badge-background-color': backgroundColor,
              '--elo-status-badge-color': badgeColor,
            } as React.CSSProperties
          }
          onClick={onClick}
        >
          {icon}
          {label}
          {children}
        </div>
      )}
    </>
  )
}
